/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuFilterLocation_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterDeliveryOptions_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterDeliveryOptions_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuFilterLocation_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterDeliveryOptions_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterDeliveryOptions_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterLocation_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ea3e94bd9b31a62a6de9e2bce2dcaa2a';
module.exports = node;
